import React from 'react'
import { useSelector } from 'react-redux'
import {
  icons,
  ColourButton,
  Label,
  NavButtonDecorator,
  Spacer
} from 'portal/lib/primitives'

import * as ADMIN_ROUTES from 'portal/routes-to-admin'

export const ViewInAdminButton = ({ record, accountId, moduleName }) => {
  const selfState = useSelector(state => state.auth)

  if (selfState && selfState.isQualisFlowInternal) {
    const href = ADMIN_ROUTES.RECORD.EDIT.replace(':accountId', accountId)
      .replace(':projectId', record.projectId)
      .replace(':recordId', record.recordId)
      .replace(
        ':moduleName',
        moduleName.toLowerCase() === 'delivery' ? 'Delivery' : 'Waste'
      )

    return (
      <NavButtonDecorator to={href}>
        <ColourButton.Basic>
          <icons.NewTabIcon colour="currentColor" />
          <Spacer.Fine />
          <Label isChild colour="inherit">
            View in Admin Portal
          </Label>
        </ColourButton.Basic>
      </NavButtonDecorator>
    )
  }

  return null
}
